import { TableCell, TableRow } from '@hivewatch/dark'

import { SOPsRowDataType } from '../types/types'
import { SOPsColumnIProps } from './Columns'

interface SOPsTableRowIProps {
  columns: SOPsColumnIProps[]
  row: SOPsRowDataType
  onClick: (row: SOPsRowDataType) => void
}

export const SOPsTableRow = ({ columns, row, onClick }: SOPsTableRowIProps) => {
  return (
    <TableRow onClick={() => onClick(row)}>
      {columns.map((col) => (
        <TableCell key={col.key} {...col.style}>
          {col.cell(row)}
        </TableCell>
      ))}
    </TableRow>
  )
}
